/** @format */

//

// 是否需要审核，00：不需要，01：需要,多个选项逗号分隔
export enum DictExamineType {
  no = '00',
  yes = '01'
}
export const dictExamineTypeMap: {
  [key: string]: string;
} = {
  [DictExamineType.yes]: '是',
  [DictExamineType.no]: '否'
};
// 是否生效00：失效，01生效
export enum DictEffectType {
  no = '00',
  yes = '01'
}
export const dictEffectTypeMap: {
  [key: string]: string;
} = {
  [DictEffectType.yes]: '生效中',
  [DictEffectType.no]: '已禁用'
};

// 计费设置 00：统一计费，01 分区域独立计费
export enum DictBillingSettingsType {
  UnifiedPricing = '00',
  Separatebilling = '01'
}
export const dictBillingSettingsTypeMap: {
  [key: string]: string;
} = {
  [DictBillingSettingsType.UnifiedPricing]: '统一计费',
  [DictBillingSettingsType.Separatebilling]: '分区域独立计费'
};

// 授权状态 ：00 待审核 01 生效中， 02 已生效 ，03 已退费 ，04 已过期
// 00 待审核，01 待生效， 02 正常 ，04 已过期 ，05 审核未通过
export enum DictAuthorizationStatusType {
  Toaudit = '00',
  Effectof = '01',
  tookeffect = '02',
  stale = '04',
  error = '05'
}
export const dictAuthorizationStatusTypeMap: {
  [key: string]: string;
} = {
  [DictAuthorizationStatusType.Toaudit]: '待审核',
  [DictAuthorizationStatusType.Effectof]: '待生效',
  [DictAuthorizationStatusType.tookeffect]: '正常',
  [DictAuthorizationStatusType.stale]: '已过期',
  [DictAuthorizationStatusType.error]: '审核未通过'
};

// 操作类型 01 新增 02审核  03 续期 04 禁用
export enum DictoperationType {
  increased = '01',
  check = '02',
  renew = '03',
  forbidden = '04'
}
export const dictoperationTypeMap: {
  [key: string]: string;
} = {
  [DictoperationType.increased]: '新增',
  [DictoperationType.check]: '审核',
  [DictoperationType.renew]: '续费',
  [DictoperationType.forbidden]: '禁用'
};
// 生效时段 00 全天 01 分时段
export enum DictEffectiveTime {
  all = '00',
  eachTime = '01'
}
export const dictEffectiveTimeMap: {
  [key: string]: string;
} = {
  [DictEffectiveTime.all]: '全天',
  [DictEffectiveTime.eachTime]: '分时段'
};

// 审核意见 01 通过 02 不通过
export enum DictauditOpinion {
  pass = '01',
  noPass = '02'
}
export const dictauditOpinionMap: {
  [key: string]: string;
} = {
  [DictauditOpinion.pass]: '通过',
  [DictauditOpinion.noPass]: '不通过'
};

// 下发状态 00:下发中，01：下发成功，02：下发失败
export enum DictIssuedOpinion {
  pass = '00',
  noPass = '01',
  error = '02'
}
export const dictIssuedOpinionMap: {
  [key: string]: string;
} = {
  [DictIssuedOpinion.pass]: '下发中',
  [DictIssuedOpinion.noPass]: '下发成功',
  [DictIssuedOpinion.error]: '下发失败'
};

// 操作类型 01新增 02续期 03审核通过 04审核拒绝 05删除
export enum DictopOpinion {
  add = '01',
  xufei = '02',
  pass = '03',
  no = '04',
  delete = '05',
  edit = '06'
}
export const dictopOpinionMap: {
  [key: string]: string;
} = {
  [DictopOpinion.add]: '新增',
  [DictopOpinion.xufei]: '续期',
  [DictopOpinion.pass]: '审核通过',
  [DictopOpinion.no]: '审核拒绝',
  [DictopOpinion.delete]: '删除',
  [DictopOpinion.edit]: '修改'
};

// 审核意见 01 通过 02 不通过
export enum Desshiyouh {
  pass = '01',
  noPass = '02'
}
export const dicDesshiyouhMap: {
  [key: string]: string;
} = {
  [Desshiyouh.pass]: '时长优惠',
  [Desshiyouh.noPass]: '金额优惠'
};
